import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

type SafeArg = 'bypassSecurityTrustUrl'
  | 'bypassSecurityTrustResourceUrl'
  | 'bypassSecurityTrustHtml'
  | 'bypassSecurityTrustStyle'
  | 'bypassSecurityTrustScript';

@Pipe({
  name: 'safe',
  standalone: true,
})
export class SafePipe implements PipeTransform {
  protected readonly domSanitizer: DomSanitizer = inject(DomSanitizer);

  public transform(content: string | undefined, arg: SafeArg): any {
    return content ? this.domSanitizer[arg](content) : '';
  }
}
